function teamName(teamIds, teamData) {
  const Ids = teamIds.join(",");
  const selectNames = teamData
    .filter((item) => Ids.includes(item.id))
    .map((item) => item.name);
  const TeamNames = selectNames.join(",");
  return TeamNames;
}
export { teamName };
